<template>
  <div class="city-selector-v2" @click="click">
    <slot
      name="icon"
    />
    <span class="city-selector-v2__current">{{
      otherCityMode ? 'Изменить город' : activeCity.name
    }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CitySelectorV2',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    iconMode: {
      type: Boolean,
      default: false,
    },
    arrowIcon: {
      type: Boolean,
      default: true,
    },
    newLanding: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['onChangeVcp'],
  data () {
    return {
      isBodyOpen: false,
      selectedCity: null,
    }
  },
  computed: {
    ...mapGetters({
      activeCity: 'city/getActive',
      otherCityMode: 'city/isOtherCityMode',
    }),
  },
  created () {
    this.selectedCity = this.activeCity
  },
  methods: {
    click () {
      this.sendGTMMarkupEvent({ block: 'Navbar', element: 'CitySelector', action: 'Click', details: '' })
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss">

.city-selector-v2 {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  @include padding-y(0rem);
  @include padding-x(0rem);
  &__arrow-icon {
    width: 0.12rem;
    height: 0.12rem;
    transition: transform .3s;
    &--open {
      transform: rotate(180deg);
    }
  }
}

.city-selector-v2__current {
  font-size: 0.16rem;
  margin-right: 0.05rem;
}

</style>
